import { render } from "./Services.vue?vue&type=template&id=7e9e2bbd"
const script = {}
script.render = render

export default script